import { Map } from 'immutable';

import MeetingItemsConstants from 'Shared/constants/MeetingItems.constants';

class MeetingItemHelper {
  static getId(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ID);
  }

  static getUuid(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.UUID, null);
  }

  static getItemType(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ITEM_TYPE);
  }

  static getIsHighPriority(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.IS_HIGH_PRIORITY);
  }

  static getCompleted(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.COMPLETED);
  }

  static getCompletedAt(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.COMPLETED_AT);
  }

  static getParentUuid(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.PARENT_UUID);
  }

  static getParentId(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.PARENT_ID);
  }

  static getParentIsSection(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.PARENT_IS_SECTION);
  }

  static getBody(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.BODY);
  }

  static getBodyRawText(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.BODY_RAW_TEXT, '');
  }

  static getVideo(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.VIDEO);
  }

  static getAttachments(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ATTACHMENTS);
  }

  static getShowPreview(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }

    return meetingItem.get(MeetingItemsConstants.Model.SHOW_PREVIEW);
  }

  static getDueBy(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.DUE_BY);
  }

  static getRcurringWorkspaceItem(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.RECURRING_WORKSPACE_ITEM);
  }

  static getAssignmentAvatar(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ASSIGNMENT_AVATAR);
  }

  static getWorkspaceId(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.WORKSPACE_ID);
  }

  static getAssignee(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ASSIGNEE);
  }

  static getAssigneeId(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.getIn([MeetingItemsConstants.Model.ASSIGNEE, MeetingItemsConstants.Model.USER_ID]);
  }

  static getHistory(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.HISTORY);
  }

  static getAsanaData(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ASANA_DATA);
  }

  static getAsanaTaskId(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.getIn([MeetingItemsConstants.Model.ASANA_DATA, MeetingItemsConstants.Model.TASK_ID]);
  }

  static getAsanaTasKUrl(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.getIn([MeetingItemsConstants.Model.ASANA_DATA, MeetingItemsConstants.Model.URL]);
  }

  static getPosition(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.POSITION);
  }

  static getPositionForGoalDetailPage(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.POSITION_FOR_GOAL_DETAIL_PAGE);
  }

  static getCommentsCount(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.COMMENTS_COUNT);
  }

  static getGoalId(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.GOAL_ID);
  }

  static getGoalSlug(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.GOAL_SLUG);
  }

  static getCreatedAt(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.CREATED_AT);
  }

  static getUpdatedAt(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.UPDATED_AT);
  }

  static getIsSection(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.IS_SECTION);
  }

  static getWorkspaceName(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.WORKSPACE_NAME);
  }

  static getWorkspacePath(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.WORKSPACE_PATH);
  }

  static getAssociatedMeetingItemId(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ASSOCIATED_MEETING_ITEM_ID);
  }

  static getAssociatedMeetingItemUuid(meetingItem) {
    if (!Map.isMap(meetingItem)) {
      return false;
    }
    return meetingItem.get(MeetingItemsConstants.Model.ASSOCIATED_MEETING_ITEM_UUID);
  }
}

export default MeetingItemHelper;
